import axios, { AxiosInstance } from 'axios'
import { Url } from '../components/UrlServer'

class AxiosBaseRequest {
  instance: AxiosInstance
  authToken: string | undefined

  constructor() {
    this.instance = axios.create({
      baseURL: Url,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    this.getInterceptor()
  }

  private getInterceptor = async () => {
    this.instance.interceptors.request.use(
      config => {
        config.headers = config.headers ?? {}
        if (this.authToken) {
          config.headers.Authorization = `Bearer ${this.authToken}`
        } else {
          delete config.headers.authorization
        }
        return config
      },
      err => {
        // err handling for request
        return Promise.reject(err)
      }
    )

    this.instance.interceptors.response.use(
      response => {
        return response
      },
      err => {
        // err handling for request
        return Promise.reject(err)
      }
    )
  }

  setToken = async (token?: string) => {
    this.authToken = token
  }

  getInstance = () => {
    return this.instance
  }
}

export default new AxiosBaseRequest()
